<template>
  <CityModal
    :value="isDialogOpened"
    is-back
    :selected-city="filtersStore.unsavedFilters.city"
    @city:selected="onClickCity"
    @city:reset="onReset"
    @input="handleCloseCityModal"
  >
    <template #footer>
      <BtnShowDoctors
        :active="isDialogOpened"
        class="pa-2 elevation-8"
        @click:submit="applySelectedCity"
        @click:close="closeDialog"
      />
    </template>
  </CityModal>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import I18NextVue from 'i18next'
import { dispatchCustomEventGlobally } from 'www/utils'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'
import BtnShowDoctors from 'www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'
import CityModal from 'www/vue_components/common/TheFilters/doctors/components/CityFilters/components/CityModal.vue'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('CityFilters')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const onReset = async () => {
  closeDialog()
  filtersStore.updateFilters({ city: undefined })

  await updateDoctorListPage()

  dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
    upper: true,
    message: t('Фильтр сброшен', options.value),
  })
}

watch(
  () => filtersStore.filters.city,
  () => {
    chipsStore.updateCityChip({
      name: filtersStore.filters.city?.name || t('Город врача', options.value),
      isActive: !!filtersStore.filters.city,
      dropdown: !filtersStore.filters.city,
      isVisible: true,
      truncate: true,
      onClick: openDialog,
      onReset,
    })
  },
  { immediate: true },
)

const onClickCity = (city: NonNullable<Filters['city']>) => {
  filtersStore.updateUnsavedFilters({ city })
}

function applySelectedCity() {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  updateDoctorListPage()
}

function handleCloseCityModal() {
  closeDialog()
  filtersStore.resetUnsavedFilters()
}
</script>
